const stats = [
  { num: "+20", suf: "AÑOS", sub: "Líderes en Monterrey y el norte de México" },
  { num: "+10,000", suf: "TECHOS", sub: "Instalados en toda Latinoamérica" },
  { num: "+30", suf: "CIUDADES", sub: "Con instalación propia" },
  { num: "IFAI", suf: "2021", sub: "Reconocimiento internacional en tensoestructuras" },
];

export default function StatsBar() {
  return (
    <section className="bg-[#0a0a0a] py-12 md:py-16 border-y border-white/5" aria-label="Prueba social">
      <div className="container-x grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
        {stats.map((s, i) => (
          <div key={i} className="text-center md:text-left">
            <div className="flex items-baseline gap-2 justify-center md:justify-start">
              <span className="text-orange-500 font-black text-5xl md:text-6xl section-title">{s.num}</span>
              <span className="text-orange-500/80 font-bold text-lg md:text-xl">{s.suf}</span>
            </div>
            <p className="text-white/70 text-sm mt-2 max-w-xs mx-auto md:mx-0">{s.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
